// @ts-nocheck
import { getBlogSimilarArticlesDataView } from "@store/Framework/Store/Data/BlogArticle/BlogArticleSelectors";
import convertSelectorToHook from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";

export const useBlogSimilarArticlesDataView = convertSelectorToHook(getBlogSimilarArticlesDataView);
